// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2ILdA","title":"styles_title__1XqtQ"};